import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ChangeCartItemParam')
export default class ChangeCartItemParam {
  constructor() {
    this.quantity = 1;
    this.cartItemId = 0;
  }

  @JsonProperty('cart_item_id')
  public cartItemId: number;

  @JsonProperty('quantity')
  public quantity: number;
}
